import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../const/config";
import api from "../axios";

const LoginPage: React.FC = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");

    try {
      const response = await api.post(
        "/auth/login/",
        new URLSearchParams({
          username,
          password,
        }),
        {
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        }
      );

      localStorage.setItem(`${API_BASE_URL}_token`, response.data.access_token); // Store JWT token
      navigate("/"); // Redirect to a protected route
    } catch (err: any) {
      const message = err.response?.data?.detail || err.message || "Login failed";
      setError(message);
    }
  };

  return (
    <div className="bg-white shadow-md mx-auto my-10 p-6 rounded-lg container">
      <h1 className="mb-4 font-bold text-2xl">Login</h1>
      {error && <p className="text-red-500">{error}</p>}
      <form onSubmit={handleLogin}>
        <div className="mb-4">
          <label className="block">Username</label>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="p-2 border w-full"
            required
          />
        </div>
        <div className="mb-4">
          <label className="block">Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="p-2 border w-full"
            required
          />
        </div>
        <button type="submit" className="bg-blue-500 px-4 py-2 text-white">
          Login
        </button>
      </form>

      {/* Button to navigate to Signup page */}
      <div className="mt-4">
        <p>Don't have an account?</p>
        <button
          onClick={() => navigate("/signup")}
          className="text-blue-500 underline"
        >
          Sign up here
        </button>
      </div>
    </div>
  );
};

export default LoginPage;
